import request from '@/utils/request'
let resquest = process.env.VUE_APP_BASE_API

export default {
  /* ---------------------------------小说拆分区域---------------------------- */
  //小说拆分列表
  getApartList(params) {
    return request({
      url: `${resquest}/novel/app/apart/list/v2`,
      method: 'get',
      params: params
    })
  },
  //作品名初始化 
  init(params) {
    return request({
      url: `${resquest}/novel/app/apart/init`,
      method: 'post',
      data: params
    })
  },
  //拆书列表删除 
  del(params) {
    return request({
      url: `${resquest}/novel/app/apart/delete`,
      method: 'post',
      data: params
    })
  },
  //TXT文本上传和文字复制上传--使用批量章节接口 
  updateTxt(params) {
    return request({
      url: `${resquest}/novel/app/apart/chapters`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'post',
      data: params
    })
  },
  //章节列表
  chapterList(params) {
    return request({
      url: `${resquest}/novel/app/apart/chapter/list/v2`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'get',
      params
    })
  },
  //章节详情
  chapterDetail(params) {
    return request({
      url: `${resquest}/novel/app/apart/chapter/details`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'get',
      params
    })
  },
  //拆书详情
  apartDetail(params) {
    return request({
      url: `${resquest}/novel/app/apart/details`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'get',
      params
    })
  },
  //拆书提取分类
  apartClassify(params) {
    return request({
      url: `${resquest}/novel/app/apart/params`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'get',
      params
    })
  },
  //转剧本参数分类
  novelTurnClassify(params) {
    return request({
      url: `${resquest}/novel/app/apart/nparams`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'get',
      params
    })
  },
  //拆书操作
  apartUnpack(params) {
    return request({
      url: `${resquest}/novel/app/apart/async`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'post',
      params
    })
  },
  //转剧本操作
  scriptUnpack(params) {
    return request({
      url: `${resquest}/novel/app/apart/novel_to_script`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'post',
      params
    })
  },
  //删除章节（通用-拆书和转剧本）
  delChapter(params) {
    return request({
      url: `${resquest}/novel/app/apart/chapter/delete`,
      method: 'post',
      data:params
    })
  },
  //生成拆书内容
  generatorText(id,params){
    return request({
      url: `${resquest}/novel/app/writer/app/question/async/${id}`,
      headers: {
        "Content-Type": 'multipart/form-data'
      },
      method: 'get',
      params
    })
  },
  //仿写类型
  mimicClassify(params){
    return request({
      url: `${resquest}/novel/app/apart/mparams`,
      headers: {
         "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'get',
      params
    })
  },
  //仿写ai生成
  mimicCreate(params){
    return request({
      url: `${resquest}/novel/app/apart/mimic`,
      headers: {
         "Content-Type": 'application/x-www-form-urlencoded'
      },
      method: 'post',
      data:params
    })
  },
  
  //仿写记录
  apartLogList(params){
    return request({
      url: `${resquest}/novel/app/apart/mimic/log`,
      headers: {
         "Content-Type": 'application/x-www-form-urlencoded'
      },
      method: 'get',
      params
    })
  },
  //仿写详情
  apartLogDetail(params){
    return request({
      url: `${resquest}/novel/app/apart/mimic/details`,
      method: 'get',
      params
    })
  },
  //删除仿写记录
  mimicDel(params){
    return request({
      url: `${resquest}/novel/app/apart/mimic/delete`,
      headers: {
         "Content-Type": 'application/x-www-form-urlencoded'
      },
      method: 'post',
      params
    })
  },
  //仿写章节记录
  chapterLogList(params){
    return request({
      url: `${resquest}/novel/app/apart/mimic/list`,
      headers: {
         "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'get',
      params
    })
  },
}